import React from "react";
import { mainRoute } from "helpers/staticData";
import PrivateRoute from "helpers/pivateRoute";

function MainRoute() {
  return mainRoute.map((item, index) => (
    <PrivateRoute key={index} exact={item.exact} path={item.url}>
      {item.component}
    </PrivateRoute>
  ));
}

export default MainRoute;
